import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { IThemeListProps, IThemeListItem } from './types';
import ClientLogo from '../../../clientLogo';
import { useMediaQuery } from 'beautiful-react-hooks';
import styles from './ThemeList.module.css';

export const ThemeList: React.FC<IThemeListProps> = ({ themes }) => {
  const isSmall = useMediaQuery('(max-width: 48rem)');
  const rowClass = isSmall ? '' : styles.fullHeightRow;

  const renderListItem = (theme: IThemeListItem) => (
    <tr key={theme.id} className={`${rowClass}`}>
      <td>
        <Link to={`/admin/themes/${theme.id}`}>{theme.name}</Link>
      </td>
      {!isSmall && (
        <td>
          <ClientLogo imageUrl={theme.logoUrl} />
        </td>
      )}
      <td>{theme.welcomePages}</td>
    </tr>
  );

  return (
    <Table hover>
      <thead>
        <tr>
          <th>Name</th>
          {!isSmall && <th>Logo</th>}
          <th>Pages</th>
        </tr>
      </thead>
      <tbody>{themes.map(renderListItem)}</tbody>
    </Table>
  );
};
